import { render } from "./AquaparkBlock.vue?vue&type=template&id=5da10d36&scoped=true"
import script from "./AquaparkBlock.vue?vue&type=script&lang=js"
export * from "./AquaparkBlock.vue?vue&type=script&lang=js"

import "./AquaparkBlock.vue?vue&type=style&index=0&id=5da10d36&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da10d36"]])

export default __exports__